import { render, staticRenderFns } from "./InfinityTable.vue?vue&type=template&id=3a49d6b0&"
import script from "./InfinityTable.vue?vue&type=script&lang=ts&"
export * from "./InfinityTable.vue?vue&type=script&lang=ts&"
import style0 from "./InfinityTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InfinityTable.vue"
export default component.exports